<template>
  <section class="bg-blue py-20">
    <div class="max-w-6xl mx-auto px-6 md:px-10 lg:px-12">
      <h2 class="text-center text-xl font-semibold text-yellow story-style">
        TESTIMONIAL
      </h2>
      <p class="text-center mt-3 mb-8 text-lg text-white">
        What our clients say about us
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-10">
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="p-6 shadow-xl rounded-xl bg-white cursor-pointer transition-transform transform hover:scale-105"
        >
          <div class="flex justify-center">
            <div
              class="w-20 h-20 rounded-full overflow-hidden border-4 border-blue-500 -mt-12"
            >
              <img
                src="../assets/images/avatar_11916312.png"
                alt="Avatar"
                class="w-full h-full object-cover"
              />
            </div>
          </div>

          <div class="mt-6 text-center">
            <p
              class="text-gray-700 text-base leading-relaxed"
              :class="{ 'line-clamp-3': !testimonial.expanded }"
            >
              "{{ testimonial.text }}"
            </p>
            <div class="flex items-center justify-end">
                <button
                  v-if="testimonial.showToggle"
                  @click="toggleReadMore(index)"
                  class=" text-blue underline"
                >
                  {{ testimonial.expanded ? "read less" : "read more" }}
                </button>
            </div>

            <p class="mt-5 text-lg font-bold text-gray-900">
              {{ testimonial.name }}
            </p>
            <p class="text-gray-500 text-sm">{{ testimonial.role }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      textLengthThreshold: 150,
      testimonials: [
        {
          text: "I've watched and followed the growth process of Mshel Homes from its inception till date and still counting and I can confidently say that the level of excellence and reliability is second to none within the city of Abuja. The ROI alone makes me always keep coming back and also recommend friends and business associates. So I will say no regrets investing in Mshel Homes Limited!",
          name: "Ebenezer Edwin",
          role: "Client",
          expanded: false,
          showToggle: false,
        },
        {
          text: "I have been privileged to work where a lot of developers are reported for fraud and other vices, Mshel has NEVER been one on my register. I was very satisfied with my purchase!",
          name: "Mustapha Sulaiman",
          role: "Client",
          expanded: false,
          showToggle: false,
        },
        {
          text: "I couldn't be more impressed from buying a property with your company and I am more likely to buy more!",
          name: "Oghani Joel Elo",
          role: "Client",
          expanded: false,
          showToggle: false,
        },
      ],
    };
  },
  mounted() {
    this.testimonials.forEach((testimonial) => {
      testimonial.showToggle =
        testimonial.text.length > this.textLengthThreshold;
    });
  },
  methods: {
    toggleReadMore(index) {
      this.testimonials[index].expanded = !this.testimonials[index].expanded;
    },
  },
};
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.story-style {
  font-family: "Caveat";
}
</style>
